export default function isFunction(f: any): boolean {
  return typeof f === 'function';
}
